module.exports = __webpack_public_path__ + "img/vbet_02.ffa63b76.jpg";